<template>
  <div class="portfolio-case-study container" id="trofi">
    <CsVideoIntro v-bind="project.caseStudy.intro"></CsVideoIntro>
    <CsSynopsis v-bind="project.caseStudy.synopsis"></CsSynopsis>
    <CsShowcase v-bind="project.caseStudy.showcase"></CsShowcase>
    <CsImageGrid v-bind="project.caseStudy.imageGrid"></CsImageGrid>
    <CallToAction v-bind="cta" />
  </div>
</template>

<script>
import { cloudview, cta } from "@/data/projects.js";
import CallToAction from "@/components/CallToAction";
import CsVideoIntro from "@/components/CsVideoIntro/CsVideoIntro";
import CsSynopsis from "@/components/CsSynopsis/CsSynopsis";
import CsShowcase from "@/components/CsShowcase/CsShowcase";
import CsImageGrid from "@/components/CsImageGrid/CsImageGrid";

export default {
  name: "Cloudview",
  metaInfo: {
    title: `Cloudview`,
    meta: [
      {
        name: "description",
        content: `Cloudview is an all inclusive entertainment system for British Airways. Users will be able to enjoy numerous streaming entertainments as well as on-board services as their disposal.`,
      },
    ],
  },
  data() {
    return {
      project: cloudview,
      cta: cta,
    };
  },
  components: {
    CallToAction,
    CsVideoIntro,
    CsSynopsis,
    CsShowcase,
    CsImageGrid,
  },
};
</script>
